var _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinalizeDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    height: 112,
    width: 112,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFF7E0"
    },
    points: "500,451.47 500,500 0,500 0,451.47 34.55,354.06 160.14,0 339.86,0 381.21,116.58  409.37,195.98 414.38,210.08 466.08,355.85 469.05,364.22 470.8,369.15 478.25,390.15 487.46,416.12  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87FFF4"
    },
    d: "M382.509,256.914l0.725-0.513c2.23-1.578,5.345-1.045,6.923,1.185l68.85,97.281 c1.578,2.23,1.045,5.345-1.185,6.923l-0.725,0.513c-2.23,1.578-5.345,1.045-6.923-1.185l-68.85-97.281 C379.746,261.607,380.279,258.492,382.509,256.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87FFF4"
    },
    d: "M452.332,124.325L349.419,356.877H50.838L157.18,116.583h287.328l7.762,7.762 C452.27,124.345,452.291,124.335,452.332,124.325z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00B4A4"
    },
    points: "444.508,116.583 345.836,339.551 338.167,356.877 39.586,356.877 52.238,328.299  144.343,120.176 145.928,116.583  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.62,
    y: 358.92,
    style: {
      fill: "#00B4A4"
    },
    width: 18.4,
    height: 141.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.82,
    y: 358.92,
    style: {
      fill: "#87FFF4"
    },
    width: 9.2,
    height: 141.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.05,
    y: 358.92,
    style: {
      fill: "#00B4A4"
    },
    width: 18.41,
    height: 141.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.25,
    y: 358.92,
    style: {
      fill: "#87FFF4"
    },
    width: 9.21,
    height: 141.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.29,
    y: 358.92,
    style: {
      fill: "#00B4A4"
    },
    width: 18.4,
    height: 141.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.49,
    y: 358.92,
    style: {
      fill: "#87FFF4"
    },
    width: 9.2,
    height: 141.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.45,
    y: 358.92,
    style: {
      fill: "#00B4A4"
    },
    width: 18.41,
    height: 141.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.66,
    y: 358.92,
    style: {
      fill: "#87FFF4"
    },
    width: 9.2,
    height: 141.08
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.49,
      fill: "#008F82"
    },
    points: "345.836,339.551 338.167,356.877 39.586,356.877 52.238,328.299  144.343,120.176 127.305,318.89  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.586,
    y: 355.853,
    style: {
      fill: "#27D6C7"
    },
    width: 452.981,
    height: 13.293
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.19,
    y: 355.853,
    style: {
      fill: "#87FFF4"
    },
    width: 153.378,
    height: 13.293
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D3014"
    },
    d: "M117.382,44.862l-52.759,76.467l-9.759-2.79l5.981-8.277l51.431-71.217c0,0,0.927-0.69,2.79,0.463 C116.918,40.672,117.382,44.862,117.382,44.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#420D0B"
    },
    d: "M117.382,44.862l-52.759,76.467l-9.759-2.79l5.981-8.277l4.859,0.762l49.362-71.516 C116.918,40.672,117.382,44.862,117.382,44.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB337"
    },
    d: "M187.581,96.924c0,0,14.643,13.016,15.573,14.643c0.93,1.627-0.697,5.113-0.697,5.113h-13.714 c0,0-0.465,6.973-4.416,8.135c-3.951,1.162-9.065-1.162-9.762-4.184s6.043-18.827,7.438-20.454 C183.397,98.552,187.581,96.924,187.581,96.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7129"
    },
    d: "M188.046,99.481c0,0-1.833,21.616-8.006,22.546c-6.172,0.93-6.405-3.951-5.243-9.995 c1.162-6.043,2.324-12.319,3.022-13.946c0.697-1.627,5.346-2.324,8.368-1.627C189.208,97.157,188.046,99.481,188.046,99.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D3014"
    },
    d: "M183.647,103.417c0,0,0,0.01-0.01,0.01l-0.824,0.803c-1.791,1.729-4.674,1.678-6.413-0.113 l-55.405-57.371l-3.263-3.387c-1.729-1.791-1.678-4.674,0.113-6.413l0.834-0.803c1.791-1.729,4.674-1.678,6.403,0.113 l58.678,60.758C185.49,98.805,185.438,101.687,183.647,103.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB337"
    },
    d: "M121.337,47.416c0,0,8.832-9.297,9.065-10.46c0.232-1.162-3.254-7.903-11.854-7.438 c-8.6,0.465-10.459,6.276-9.995,7.903C109.018,39.049,118.548,49.973,121.337,47.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD69D"
    },
    d: "M82.03,145.418c-2.471,2.893-6.486,4.025-11.077,3.552c-5.065-0.525-10.819-3.006-15.998-7.258 c-0.216-0.165-0.422-0.34-0.628-0.515c-10.006-8.534-13.815-20.496-8.513-26.704c1.451-1.699,3.428-2.79,5.754-3.304 c6.156-1.369,14.69,1.328,21.948,7.525c0.391,0.329,0.762,0.669,1.132,1.009C83.801,128.175,87.126,139.447,82.03,145.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB337"
    },
    d: "M127.141,119.857l-52.852,61.9L63.85,193.977c0,0-9.811-5.744-9.965-17.161 c-0.165-11.242,13.939-22.133,1.071-35.104c-0.185-0.196-0.381-0.391-0.576-0.577l7.875-9.224l11.211-13.125 c0.391,0.329,0.782,0.648,1.184,0.937c9.821,7.237,21.392,2.1,28.032-5.384C109.589,106.557,127.141,119.857,127.141,119.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#420D0B"
    },
    d: "M183.647,103.417c0,0,0,0.01-0.01,0.01l-0.824,0.803 c-1.791,1.729-4.674,1.678-6.413-0.113l-55.405-57.371l1.338-6.403L183.647,103.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#730303"
    },
    d: "M74.289,181.758L63.85,193.977c0,0-9.811-5.744-9.965-17.161 c-0.165-11.242,13.939-22.133,1.071-35.104c-0.216-0.165-0.422-0.34-0.628-0.515c-10.006-8.534-13.815-20.496-8.513-26.704 c1.451-1.699,3.428-2.79,5.754-3.304c-5.899,8.308,3.583,14.196,10.686,20.723c0.576,0.525,1.132,1.06,1.668,1.596 c5.034,5.075,7.031,9.327,7.031,15.462c0,3.644-0.7,7.958-1.863,13.506C66.537,174.593,72.127,180.131,74.289,181.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7129"
    },
    d: "M127.138,119.862c2.475,2.113-9.676,20.424-27.149,40.887 c-17.478,20.469-33.659,35.338-36.134,33.225c-2.091-1.785,6.191-15.024,19.285-31.372c2.458-3.087,5.098-6.276,7.869-9.521 c2.771-3.246,5.501-6.346,8.166-9.257C113.264,128.337,125.048,118.077,127.138,119.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD69D"
    },
    d: "M99.175,143.824c3.694,5.057,3.882,11.764,0.04,16.264c-3.847,4.506-10.501,5.371-16.074,2.515 c2.458-3.087,5.098-6.276,7.869-9.521C93.781,149.836,96.511,146.736,99.175,143.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "#FFF4E6"
    },
    d: "M118.908,119.91c-6.789-4.903-9.358-4.122-12.812-1.337 c-3.454,2.785-15.04,9.581-24.398,6.239c-9.358-3.342-12.812-7.91-17.491-10.249c-4.679-2.34-5.904,1.114-4.679,2.674 c1.225,1.56,14.817,13.48,22.95,14.594c8.133,1.114,20.722-7.019,23.952-8.467c3.231-1.448,3.899-0.557,8.133,0.223 S120.913,121.358,118.908,119.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFF4F0"
    },
    points: "319.672,299.615 153.001,299.615 217.75,146.277 387.584,146.277  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFF6F2"
    },
    points: "319.672,297.213 153.001,297.213 217.75,143.875 387.584,143.875  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "318.642,295.154 151.971,295.154 216.72,141.816 386.554,141.816  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C4D96"
    },
    points: "248.136,192.854 204.735,192.854 218.589,160.135 262.164,160.135  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M241.014,205.534h-39.963c-0.931,0-1.368-0.749-0.977-1.673l0,0 c0.391-0.924,1.463-1.673,2.394-1.673l39.98,0c0.931,0,1.365,0.749,0.968,1.673l0,0 C243.02,204.785,241.945,205.534,241.014,205.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M236.924,215.078h-39.917c-0.93,0-1.367-0.747-0.977-1.669l0,0c0.39-0.922,1.461-1.669,2.391-1.669 l39.933,0c0.93,0,1.364,0.747,0.968,1.669l0,0C238.928,214.331,237.854,215.078,236.924,215.078z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C4D96"
    },
    points: "298.77,192.854 255.369,192.854 269.426,160.135 313,160.135  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M291.57,205.534l-39.963,0c-0.931,0-1.363-0.749-0.967-1.673l0,0 c0.397-0.924,1.474-1.673,2.405-1.673h39.98c0.931,0,1.36,0.749,0.958,1.673l0,0C293.581,204.785,292.501,205.534,291.57,205.534z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M287.421,215.078l-39.916,0c-0.93,0-1.362-0.747-0.966-1.669l0,0 c0.396-0.922,1.471-1.669,2.401-1.669h39.933c0.93,0,1.359,0.747,0.958,1.669l0,0 C289.429,214.331,288.351,215.078,287.421,215.078z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C4D96"
    },
    points: "349.404,192.854 306.004,192.854 320.263,160.135 363.837,160.135  "
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "298.77,192.854 255.369,192.854 269.426,160.135 313,160.135  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103231077051639712280000008413765846194240384_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103231077051639712280000008413765846194240384_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M276.127,188.696c-2.65,6.136-4.387,11.103-12.795,11.103 c-8.408,0-5.863-4.967-3.225-11.103c2.642-6.145,8.378-11.133,12.808-11.133S278.781,182.551,276.127,188.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M281.523,171.787c-1.321,3.06-4.685,5.539-7.513,5.539 c-2.829,0-4.055-2.479-2.738-5.539c1.318-3.062,4.684-5.546,7.517-5.546C281.621,166.24,282.845,168.724,281.523,171.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M298.407,187.388c-2.981,6.859-4.937,12.411-14.334,12.411 c-9.397,0-6.539-5.552-3.573-12.411c2.971-6.871,9.398-12.449,14.35-12.449S301.393,180.517,298.407,187.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M304.492,168.478c-1.487,3.423-5.255,6.195-8.417,6.195 c-3.163,0-4.526-2.772-3.045-6.195c1.483-3.425,5.254-6.204,8.421-6.204C304.619,162.274,305.98,165.053,304.492,168.478z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000091714691155280496240000004169745780860841623_",
    points: "248.136,192.854 204.735,192.854  218.589,160.135 262.164,160.135  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086665459577121491300000007726616617643814555_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091714691155280496240000004169745780860841623_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000086665459577121491300000007726616617643814555_)",
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: " M237.279,192.612c0.076-0.178,0.519-6.784,0.519-6.784s-0.079-0.083-0.228-0.201c-0.476-1.161-1.738-4.428-1.677-6.281 c0.011-0.324,0.029-0.637,0.052-0.942l2.521,0.495l4.122,4.025l1.684-1.207l-1.89-6.936l-7.02-2.247 c-0.177-0.148-0.332-0.26-0.428-0.327l-0.574-1.776c0.783-0.8,1.444-1.742,1.876-2.755c1.23-2.888,0.151-5.23-2.411-5.23 s-5.634,2.342-6.861,5.23c-1.226,2.886-0.145,5.223,2.414,5.223c0.37,0,0.752-0.054,1.137-0.147l0.269,1.79 c-2.187,1.334-5.775,2.198-5.896,2.26c-0.173,0.089-6.028-1.798-6.028-1.798s0.279-1.613-0.584-2.016 c-0.863-0.403-2.608,1.165-2.352,3.001c0.256,1.835,5.887,5.289,5.887,5.289l5.707-1.429c-0.148,1.153-0.561,4.761-0.2,6.439 l-6.848,3.646l-4.197,7.445l2.389,1.024l4.225-5.079l6.467-3.194l2.162,5.155l5.049,3.296l4.143-2.138 C240.708,196.445,237.203,192.79,237.279,192.612z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M346.322,178.082l-0.634,0.208 c-0.231-1.279-1.277-2.132-2.896-2.132h-15.742c-1.619,0-3.413,0.853-4.765,2.132l-0.442-0.208l6.801-9.535h19.239 L346.322,178.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M318.198,181.4h-1.214c-0.7,0-1.023-0.57-0.72-1.266 l2.153-4.934c0.304-0.697,1.126-1.268,1.827-1.268h1.215c0.7,0,1.024,0.571,0.719,1.268l-2.156,4.934 C319.719,180.83,318.897,181.4,318.198,181.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M348.387,181.4h-1.214c-0.7,0-1.021-0.57-0.715-1.266 l2.172-4.934c0.307-0.697,1.131-1.268,1.831-1.268h1.215c0.7,0,1.022,0.571,0.715,1.268l-2.174,4.934 C349.91,180.83,349.086,181.4,348.387,181.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M323.017,189.379l-0.835,1.907 c-0.422,0.964-1.559,1.751-2.528,1.751h-1.668c-0.97,0-1.418-0.787-0.996-1.751l1.5-3.432c0.009-0.021,0.018-0.042,0.038-0.062 c0.398,0.975,1.361,1.587,2.738,1.587H323.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M339.524,188.768l-1.108,2.519 c-0.424,0.964-1.562,1.751-2.521,1.751h-1.678c-0.969,0-1.406-0.787-0.982-1.751l0.837-1.907h2.91 C337.806,189.379,338.688,189.151,339.524,188.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M336.987,189.378h-15.721c-2.481,0-3.619-2-2.54-4.469 l1.866-4.27c1.081-2.473,3.972-4.479,6.457-4.479h15.746c2.485,0,3.617,2.006,2.529,4.479l-1.878,4.27 C342.359,187.377,339.468,189.378,336.987,189.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M321.979,186.272L321.979,186.272 c-1.11,0-1.623-0.903-1.141-2.008l0.622-1.423c0.483-1.105,1.787-2.01,2.898-2.01l0,0c1.111,0,1.624,0.904,1.14,2.01 l-0.623,1.423C324.393,185.369,323.089,186.272,321.979,186.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#88C0FF",
      strokeMiterlimit: 10
    },
    d: "M338.715,186.272L338.715,186.272 c-1.11,0-1.621-0.903-1.136-2.008l0.625-1.423c0.485-1.105,1.792-2.01,2.902-2.01l0,0c1.111,0,1.622,0.904,1.136,2.01 l-0.626,1.423C341.13,185.369,339.825,186.272,338.715,186.272z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M342.126,205.534h-39.963c-0.931,0-1.359-0.749-0.956-1.673l0,0 c0.403-0.924,1.484-1.673,2.415-1.673h39.98c0.931,0,1.355,0.749,0.948,1.673l0,0 C344.141,204.786,343.057,205.534,342.126,205.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M337.918,215.078h-39.916c-0.93,0-1.358-0.747-0.956-1.669l0,0 c0.402-0.922,1.481-1.669,2.411-1.669h39.933c0.93,0,1.354,0.747,0.948,1.669l0,0 C339.931,214.331,338.848,215.078,337.918,215.078z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C4D96"
    },
    points: "219.503,259.638 176.456,259.638 190.085,227.452 233.302,227.452  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M212.483,272.112l-39.638,0c-0.923,0-1.359-0.736-0.975-1.645l0,0 c0.385-0.909,1.446-1.646,2.369-1.646h39.654c0.923,0,1.356,0.737,0.966,1.646l0,0 C214.471,271.376,213.406,272.112,212.483,272.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M208.46,281.501l-39.592,0c-0.922,0-1.358-0.735-0.974-1.642l0,0 c0.384-0.907,1.443-1.642,2.365-1.642h39.608c0.922,0,1.355,0.735,0.966,1.642l0,0 C210.444,280.767,209.382,281.501,208.46,281.501z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C4D96"
    },
    points: "269.724,259.638 226.677,259.638 240.505,227.452 283.723,227.452  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M262.627,272.112H222.99c-0.923,0-1.355-0.737-0.965-1.645l0,0 c0.391-0.909,1.456-1.646,2.379-1.646h39.654c0.923,0,1.352,0.737,0.956,1.646l0,0 C264.619,271.376,263.55,272.112,262.627,272.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M258.546,281.501h-39.592c-0.922,0-1.354-0.735-0.964-1.642l0,0 c0.39-0.907,1.453-1.642,2.376-1.642h39.608c0.922,0,1.35,0.735,0.956,1.642v0C260.535,280.767,259.468,281.501,258.546,281.501z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C4D96"
    },
    points: "319.945,259.638 276.898,259.638 290.926,227.452 334.143,227.452  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M312.771,272.112h-39.637c-0.923,0-1.351-0.737-0.954-1.645l0,0 c0.396-0.909,1.466-1.646,2.389-1.646l39.654,0c0.923,0,1.347,0.737,0.946,1.646l0,0 C314.767,271.376,313.694,272.112,312.771,272.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5CA9FF"
    },
    d: "M308.631,281.501H269.04c-0.922,0-1.349-0.735-0.954-1.642l0,0 c0.395-0.907,1.464-1.642,2.386-1.642h39.608c0.922,0,1.346,0.735,0.946,1.642l0,0 C310.625,280.767,309.553,281.501,308.631,281.501z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083364"
    },
    d: "M127.222,428.691c0,0-5.795,5.933-9.22,9.645c-3.425,3.712,1.706,10.913,8.563,14.196 c6.856,3.283,5.476,8.219,7.574,11.694c2.098,3.475,8.995,6.461,10.353,6.072c1.358-0.388,4.612-4.397,5.194-7.29 c0.582-2.892-4.799-8.732-8.005-12.966c-3.206-4.235,1.188-9.906,1.188-9.906l-16.072-11.655"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84CDF6"
    },
    d: "M195.63,358.524c-1.009,3.129-2.924,7.33-5.456,12.168c-13.65,26.261-44.987,71.68-44.987,71.68 s-6.135,0.34-14.32-3.068c-8.184-3.408-7.155-8.174-7.155-8.174l2.316-4.746l17.871-36.7l6.053-12.415 c0,0-8.719,1.029-18.19,2.141c-9.45,1.102-19.642,2.296-22.709,2.635c-6.135,0.68-39.541,6.135-49.084-2.388 c-9.543-8.524-10.912-25.901-5.116-40.22c0,0,43.628,2.728,55.559,2.388c11.931-0.34,62.045-3.408,68.18-2.049 C184.728,341.136,202.105,338.419,195.63,358.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "#597ACF"
    },
    d: "M190.277,369.333c0.01,0.36-0.021,0.813-0.103,1.359 c-13.65,26.261-44.987,71.68-44.987,71.68s-6.135,0.34-14.32-3.068c-8.184-3.408-7.155-8.174-7.155-8.174l2.316-4.746 c5.518,3.109,12.827,6.712,14.484,5.055c2.749-2.738,19.559-45.635,19.559-45.635s-6.877,3.521-16.173,3.881 c-3.994,0.154-8.452-0.278-12.992-1.822c0,0,0.206-3.716,0.854-8.452c0.803-5.94,2.306-13.465,4.982-17.284 c4.797-6.866,17.501-6.866,35.681-5.487C190.616,358.009,189.927,360.408,190.277,369.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083364"
    },
    d: "M160.816,450.695c0,0-2.565,7.886-3.991,12.732c-1.425,4.846,6.366,9.026,13.967,8.931 s8.551,4.941,11.972,7.126c3.421,2.185,10.927,1.805,11.972,0.855c1.045-0.95,2.185-5.986,1.425-8.836 c-0.76-2.85-8.171-5.701-12.922-8.076c-4.751-2.375-3.326-9.406-3.326-9.406l-19.573-3.326"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84CDF6"
    },
    d: "M184.234,451.441c-1.194,3.325-1.894,5.25-1.894,5.25s-4.097,2.728-12.271,1.019 c-8.184-1.699-11.252-7.494-11.252-7.494s10.222-58.967,11.592-64.083c1.359-5.116,2.388-9.543,1.699-10.562 c-0.68-1.029-55.22,10.222-73.626,6.135c-18.396-4.097-22.833-11.931-26.58-21.814c-1.143-3.016-1.493-6.66-1.41-10.366 c0.185-8.431,2.635-17.151,3.109-19.292c0.69-3.068,29.319-3.407,40.22-2.728c10.912,0.679,21.824,10.912,21.824,10.912 s48.067-0.9,54.286-0.999c21.618-0.343,26.079,12.697,25.05,22.648C214.46,365.09,191.543,431.244,184.234,451.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "#597ACF"
    },
    d: "M183.41,451.349c0.278,0.021,0.546,0.052,0.823,0.093 c-1.194,3.325-1.894,5.25-1.894,5.25s-4.097,2.728-12.271,1.019c-8.184-1.699-11.252-7.494-11.252-7.494 s10.222-58.967,11.592-64.083c1.359-5.116,2.388-9.543,1.699-10.562c-0.68-1.029-55.22,10.222-73.626,6.135 c-18.396-4.097-22.833-11.931-26.58-21.814c-1.143-3.016-1.493-6.66-1.41-10.366c6.588-8.946,17.109-12.889,22.885-15.205 c5.961-2.388,31.017,6.527,31.017,6.527c1.029,12.014,4.118,25.736,4.118,25.736s30.533-0.679,46.665,2.409 c16.131,3.088,10.984,14.752,7.546,31.563c-3.428,16.821-10.294,41.868-10.294,41.868S174.485,450.659,183.41,451.349z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7366"
    },
    d: "M173.71,186.761c-0.446,5.499,0.446,8.026,1.784,11.593c1.338,3.567-1.04,5.202-3.864,4.756 c-2.824-0.446-4.459-2.527-4.459-4.31c0-1.784,1.486-7.283,2.973-8.472S173.71,186.761,173.71,186.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M179.231,164.494c-0.185,5.446-1.112,13.506-4.334,22.267 c-5.796,15.751-10.552,24.079-18.726,27.198c-8.174,3.119-20.362-1.935-20.362-1.935s-0.947,1.688-1.935,3.449 c-0.885,1.565-1.801,3.201-2.079,3.685c-0.587,1.05-17.531-3.86-20.661-5.94c-3.119-2.079-6.98-7.433-6.98-7.433 s4.756-8.03,6.836-15.751c0.257-0.968,0.484-1.915,0.69-2.821c1.39-6.413,1.39-11.303,1.39-11.303s-2.759-6.578-3.603-14.917 c-0.628-6.012-0.247-12.93,2.862-18.973c7.433-14.412,29.576-24.666,47.704-12.93c4.653,3.016,8.174,6.352,10.83,9.646 c7.71,9.543,8.205,18.746,8.205,18.746S179.385,160.15,179.231,164.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#FF8482"
    },
    d: "M179.231,164.494c-4.18-1.657-6.136-4.725-11.2-4.447 c-6.033,0.329-9.615,8.791-10.758,13.516c-1.143,4.725-18.571,4.241-18.571,4.241s6.846-9.286,3.912-14.505 c-2.934-5.209-10.912,0.659-10.758,5.219c0.165,4.56,0.659,5.538-1.462,10.583c-2.121,5.055-7.494,1.143-7.494,1.143 s-1.627,3.582-3.583,4.406c-1.956,0.813-3.099-0.824-3.099-0.824s-0.319,1.668-0.844,3.984 c-0.772,3.397-1.966,8.174-3.222,11.169c-2.121,5.055-2.934,5.703-2.934,5.703s5.044-0.484,14.011,4.077 c4.128,2.1,7.844,4.612,10.644,6.712c-0.885,1.565-1.801,3.201-2.079,3.685c-0.587,1.05-17.531-3.86-20.661-5.94 c-3.119-2.079-6.98-7.433-6.98-7.433s4.756-8.03,6.836-15.751c0.257-0.968,0.484-1.915,0.69-2.821 c1.39-6.413,1.39-11.303,1.39-11.303s-2.759-6.578-3.603-14.917c0.34-0.525,0.69-1.06,1.05-1.596 c9.286-13.856,29.813-23.461,37.307-23.461c5.003,0,15.874,1.163,23.039,2.8c7.71,9.543,8.205,18.746,8.205,18.746 S179.385,160.15,179.231,164.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#113161"
    },
    d: "M176.088,176.209c-1.189-2.824-3.419-2.973-5.053-3.121c-1.635-0.149-2.527-2.229-1.784-3.864 c0.743-1.635,4.459-1.338,6.54,0.595c2.081,1.932,1.784,2.527,1.338,4.162C176.683,175.614,176.088,176.209,176.088,176.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#113161"
    },
    d: "M172.588,184.398c-0.578,1.84-1.809,3.093-2.749,2.798c-0.94-0.295-1.233-2.027-0.654-3.867 c0.578-1.84,1.809-3.093,2.748-2.798C172.873,180.826,173.166,182.557,172.588,184.398z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFA578"
    },
    cx: 137.173,
    cy: 168.162,
    r: 4.539
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#113161"
    },
    d: "M185.304,160.005c-4.159,1.781-5.353,1.637-12.631-0.885c-7.288-2.532-10.253-2.831-15.318,2.666 c-3.15,3.438-4.571,7.515-5.219,10.531c-0.391,1.802-0.515,3.232-0.566,3.891c-0.031,0.412,0.072,0.782,0.288,1.122v0.01 c1.019,1.616,4.344,2.635,5.209,5.703c1.04,3.716,0.741,7.288,4.303,9.811c3.572,2.532,7.731,3.418,8.925,4.303 c0.556,0.422-0.134,2.656-1.441,5.25c-1.215,2.399-2.965,5.096-4.725,6.939c-0.381,0.391-0.751,0.751-1.122,1.05 c-1.307,1.071-2.563,2.079-3.902,2.913c-2.738,1.709-5.816,2.687-10.511,1.987c-6.99-1.04-12.189-1.637-14.865-4.313 c-2.09-2.079-2.172-8.596-0.844-13.825c-0.185-0.278-0.278-0.587-0.247-0.916c0.227-3.181,2.543-4.952,2.038-9.481 c-0.515-4.529-2.038-6.732-2.038-6.732l3.006-3.819c0,0,1.884,0.71,4.849,0.731c0.525-0.875,1.06-1.771,1.565-2.635 c1.143-1.935,2.11-3.655,2.378-4.334c0.165-0.422,0.288-1.246,0.319-2.265c0.113-3.706-1.102-9.893-7.155-8.143 c-7.731,2.224-7.587,13.671-9.069,15.905c-1.482,2.224-4.91,3.119-6.094,2.821c-1.194-0.299-2.079-0.885-2.079-0.885 s0,1.637-2.234,2.378c-2.224,0.741-3.274-0.299-3.274-0.299s0.309,2.666-3.86,3.861c-4.159,1.184-6.393,0.298-6.249-3.119 c0.154-3.418,2.687-4.911,3.13-10.552c0.443-5.652-3.716-13.97-2.821-21.258c0.885-7.278,5.199-10.253,5.199-10.253 s2.08-12.045,9.656-13.969c7.587-1.935,12.045-4.169,18.283-4.612c6.249-0.443,8.771,2.676,12.333,2.831 c3.572,0.144,13.084,2.821,20.96,3.263c7.772,0.432,10.336-0.566,11.983,2.697c0.021,0.041,0.041,0.093,0.062,0.134 c1.627,3.408,1.184,6.094,1.184,6.094s3.531-1.297,6.053,0.535c1.204,0.865,2.182,2.46,2.419,5.25 C193.931,149.011,189.463,158.225,185.304,160.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "#061033"
    },
    d: "M193.18,140.384c-0.237-2.79-1.215-4.385-2.419-5.25 c2.574,11.715-4.015,20.198-14.917,16.77c-11.396-3.582-23.78-1.637-26.549,5.044c-0.179,0.431-0.351,0.882-0.517,1.343 c-1.185-8.833-7.989-9.127-14.472-3.299c-6.516,5.868-6.846,6.681-6.846,6.681s-2.769,4.725-6.187,3.428 c-1.863-0.71-2.234-1.668-2.172-2.388c-0.505,1.246-1.452,3.243-2.553,3.685c-1.627,0.649-2.604-3.418-0.978-12.219 c1.627-8.792,10.428-16.78,9.77-17.099c-0.648-0.329-3.088-1.472-1.946-4.406c1.132-2.934,7.649-9.121,21.34-7.33 c11.9,1.554,32.078,8.555,38.728,3.027c-1.647-3.263-4.21-2.265-11.983-2.697c-7.875-0.443-17.387-3.119-20.96-3.263 c-3.562-0.154-6.084-3.274-12.333-2.831c-6.238,0.443-10.696,2.676-18.283,4.612c-7.577,1.925-9.656,13.969-9.656,13.969 s-4.313,2.975-5.199,10.253c-0.896,7.288,3.263,15.606,2.821,21.258c-0.443,5.641-2.975,7.134-3.13,10.552 c-0.144,3.418,2.09,4.303,6.249,3.119c4.169-1.194,3.86-3.861,3.86-3.861s1.05,1.04,3.274,0.299 c2.234-0.741,2.234-2.378,2.234-2.378s0.885,0.587,2.079,0.885c1.184,0.298,4.612-0.597,6.094-2.821 c1.482-2.234,1.338-13.681,9.069-15.905c7.721-2.234,7.577,8.472,6.835,10.408c-0.268,0.679-1.235,2.399-2.378,4.334 c-0.504,0.865-1.04,1.76-1.565,2.635c-2.965-0.021-4.849-0.731-4.849-0.731l-3.006,3.819c0,0,1.524,2.203,2.038,6.732 c0.505,4.53-1.812,6.3-2.038,9.481c-0.031,0.329,0.062,0.638,0.247,0.916c-1.328,5.229-1.246,11.746,0.844,13.825 c2.676,2.676,7.875,3.274,14.865,4.313c4.694,0.7,7.772-0.278,10.511-1.987c1.338-0.834,2.594-1.843,3.902-2.913 c0.371-0.299,0.741-0.659,1.122-1.05c-2.244-0.556-5.024-0.978-7.999-1.4c-9.121-1.307-12.055-6.033-12.703-11.571 c-0.648-5.538-5.055-15.473-5.055-15.473s1.554,0,3.562-0.957c1.379-0.659,2.975-1.76,4.427-3.613 c0.683-0.874,1.223-1.74,1.664-2.631c0.712,1.505,1.794,2.724,3.38,3.454c0.144,0.062,0.288,0.124,0.453,0.175 c-0.216-0.34-0.319-0.71-0.288-1.122c0.051-0.659,0.175-2.09,0.566-3.891c0.649-3.016,2.069-7.093,5.219-10.531 c5.065-5.497,8.03-5.199,15.318-2.666c7.278,2.522,8.472,2.666,12.631,0.885C189.463,158.225,193.931,149.011,193.18,140.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "#061033"
    },
    d: "M119.482,161.673c0,0-0.134,0.433-0.381,1.04 C119.142,162.116,119.482,161.673,119.482,161.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB2155"
    },
    d: "M168.853,202.405c-1.411,2.781-3.531,5.972-5.57,7.751c-0.089,0.089-0.184,0.164-0.273,0.239 c-1.316,1.07-2.57,2.079-3.906,2.911c-0.273-0.143-0.559-0.32-0.852-0.532c-2.427-1.732-3.504-4.452-3.374-6.974 c0.034-0.723,0.17-1.432,0.402-2.093c0.579-1.663,1.397-3.886,2.516-5.235c0.893-1.057,1.97-1.582,3.279-0.859 c2.393,1.316,4.022,3.02,6.735,4.336C168.137,202.105,168.484,202.262,168.853,202.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7F99"
    },
    d: "M163.283,210.156c-0.089,0.089-0.184,0.164-0.273,0.239c-1.316,1.07-2.57,2.079-3.906,2.911 c-0.273-0.143-0.559-0.32-0.852-0.532c-2.427-1.732-3.504-4.452-3.374-6.974C158.463,205.929,161.067,207.538,163.283,210.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M167.81,201.948c-0.498,1.411-1.677,3-3.313,2.652c-1.909-0.416-4.949-2.952-6.701-6.129 c0.893-1.057,1.97-1.582,3.279-0.859C163.467,198.928,165.096,200.632,167.81,201.948z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE3B5"
    },
    d: "M112.461,341.482c15.339,2.727,23.178-3.068,23.178-3.068s-5.113-20.792-4.09-37.494 c1.023-16.702-7.499-21.474-12.953-16.02c-5.454,5.454-12.271,31.018-11.589,40.562 C107.689,335.005,112.461,341.482,112.461,341.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD796"
    },
    d: "M137.003,231.044c0,0,0-9.544-5.113-13.293c-5.113-3.749-17.043-7.84-22.497-10.907 c-5.454-3.068-6.135-6.817-8.181-6.817c-2.045,0-7.158,7.499-7.158,7.499s1.363,5.454,5.795,8.18 c4.431,2.727,8.181,0.682,13.293,3.409c5.113,2.727,12.612,8.521,16.02,12.612c3.409,4.09,5.795,6.135,7.158,4.09 C137.685,233.771,137.003,231.044,137.003,231.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB337"
    },
    d: "M139.051,259.676c-1.349,10.727-3.531,25.263-8.061,42.598c-1.225,4.694-2.615,9.584-4.21,14.67 c-7.505,23.852-4.437,51.462-4.437,51.462s-1.493,0.515-4.159,1.071c-5.713,1.174-16.749,2.553-29.792-0.443 c-2.584-0.587-5.25-1.359-7.968-2.327c-22.843-8.184-33.745-15.339-33.745-15.339s4.427-2.388,8.174-20.115 c3.757-17.727-1.019-30.677-1.019-49.084c0-18.406,10.222-51.812,18.407-62.034c8.184-10.222,22.493-14.999,22.493-14.999 s16.708,8.863,24.202,13.3c4.427,2.615,8.853,7.124,11.736,10.387c2.007,2.265,3.263,3.922,3.263,3.922 S140.75,246.046,139.051,259.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#730303"
    },
    d: "M115.209,324.295c0.772,16.214-9.522,17.758-13.383,19.045 c-3.86,1.287-12.353,19.56-13.125,24.964c-0.031,0.237-0.134,0.484-0.309,0.731c-2.584-0.587-5.25-1.359-7.968-2.327 c-22.843-8.184-33.745-15.339-33.745-15.339s4.427-2.388,8.174-20.115c3.757-17.727-1.019-30.677-1.019-49.084 c0-18.406,10.222-51.812,18.407-62.034c8.184-10.222,22.493-14.999,22.493-14.999s16.708,8.863,24.202,13.3 c4.427,2.615,8.853,7.124,11.736,10.387c-10.48-4.416-19.704-11.571-25.757-11.334c-6.691,0.257-3.603,16.729,1.801,30.626 C112.121,262.013,114.437,308.081,115.209,324.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4591B"
    },
    d: "M126.777,316.94c-7.499,23.86-4.431,51.47-4.431,51.47s-1.5,0.511-4.165,1.064 c-1.357-6.19-3.647-21.195,0.757-38.558c4.056-15.993,9.285-24.801,12.053-28.639C129.77,306.966,128.372,311.861,126.777,316.94 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M181.866,245.285l-16.584,13.414l-8.328,6.743l-4.272,3.449c0,0-6.475-4.097-8.524-9.203 c-0.432-1.081-0.731-2.306-0.916-3.562c-0.741-4.653-0.103-9.739-0.103-9.739l28.794-10.305l0.803-0.288 c0,0,0.566-0.113,1.431,0.062c1.163,0.247,2.851,1.04,4.416,3.377c2.265,3.387,3.027,5.322,3.222,5.878 C181.845,245.223,181.866,245.285,181.866,245.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M188.403,237.677c0,0.453-0.134,0.927-0.371,1.41c-1.153,2.409-4.725,5.003-6.228,6.022 c-0.412,0.288-0.669,0.443-0.669,0.443s-6.362-1.513-7.875-3.335c-1.163-1.39-1.256-3.51-1.235-4.416 c0.01-0.268,0.021-0.432,0.021-0.432l-0.113-1.287l-0.185-2.038c0,0,0-7.494,0.865-10.171c0.093-0.329,0.206-0.576,0.34-0.741 c0.206-0.257,0.576-0.504,1.06-0.731c0.34-0.165,0.721-0.319,1.153-0.463c0.113-0.031,0.237-0.072,0.36-0.113 c0.093-0.02,0.175-0.051,0.268-0.072c0.196-0.062,0.402-0.113,0.607-0.165c0.268-0.062,0.546-0.124,0.824-0.175 c0.155-0.041,0.319-0.072,0.484-0.103c0.237-0.041,0.494-0.082,0.741-0.113c0.453-0.072,0.896-0.123,1.328-0.154 c0.34-0.021,0.669-0.041,0.968-0.041c0.134,0,0.278,0,0.402,0.01c0.669,0.021,1.194,0.113,1.503,0.298 c0.34,0.206,0.577,0.916,0.731,1.894c0.36,2.203,0.329,5.796,0.257,7.999v0.031c0,0.196-0.01,0.381-0.021,0.546 c0,0.051,0,0.093-0.01,0.134v0.144c-0.021,0.669-0.041,1.071-0.041,1.071S188.403,234.342,188.403,237.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M193.808,229.236c-0.196,2.502-4.169,7.834-5.775,9.852c-0.021,0.031-0.051,0.062-0.072,0.093 c-1.565,1.946-3.613,0-4.581-2.337c-0.978-2.337-0.391-4.581-0.391-4.581s0.237-0.185,0.618-0.484c0,0,0,0,0.01,0 c1.524-1.184,5.343-4.159,5.806-4.777c0.576-0.782,0.576-2.049,2.038-3.902c1.441-1.822,3.253-2.234,3.675-0.484 c0.021,0.031,0.021,0.062,0.031,0.093C195.558,224.562,193.993,226.703,193.808,229.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M189.185,210.736c-0.021,1.153-0.71,2.522-1.915,3.891c-1.462,1.647-3.799,6.228-3.891,8.575 c-0.103,2.337-1.657,2.234-3.222,1.647c-0.793-0.299-1.235-0.926-1.482-1.472c-0.216-0.515-0.268-0.957-0.268-0.957 c-0.062-0.309-0.031-0.762,0.041-1.225c0.124-0.999,0.443-2.09,0.443-2.09s3.706-5.168,4.097-5.559 c0.309-0.299,1.287-1.04,2.213-2.347c0.113-0.154,0.227-0.319,0.329-0.494c0.134-0.206,0.257-0.422,0.381-0.659 c1.071-2.049,2.924-1.266,3.212,0C189.175,210.263,189.196,210.5,189.185,210.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M185.613,210.726c0,0-0.062,0.124-0.165,0.34v0.01c-0.206,0.443-0.577,1.246-1.019,2.172 c-0.309,0.659-0.648,1.379-0.978,2.069c-0.474,0.999-0.937,1.935-1.246,2.522c-0.587,1.112-0.752,2.254-1.06,3.171 c-0.154,0.422-0.329,0.803-0.607,1.091c-0.113,0.124-0.237,0.227-0.381,0.319c-0.113,0.072-0.227,0.144-0.34,0.216 c-0.381,0.237-0.762,0.504-1.143,0.741c-0.319,0.206-0.638,0.391-0.947,0.546c-0.021,0.01-0.041,0.021-0.062,0.031 c-0.402,0.196-0.782,0.319-1.112,0.319c-0.865,0-1.421-0.69-1.534-0.854c-0.01-0.021-0.021-0.031-0.021-0.031 s0.062-0.607,0.165-1.451c0.093-0.854,0.227-1.946,0.36-2.913v-0.01c0.124-0.927,0.247-1.73,0.35-2.049 c0.103-0.36,0.227-0.71,0.381-1.06c0.257-0.607,0.618-1.173,1.174-1.668c0.875-0.782,4.488-2.347,5.755-3.119 c1.071-0.659,2.059-0.484,2.347-0.412C185.582,210.716,185.613,210.726,185.613,210.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M176.657,215.791c0,0,0,0.154-0.01,0.412c0,1.029-0.041,3.727-0.247,5.384 c-0.082,0.659-0.185,1.153-0.329,1.318c-0.093,0.113-0.257,0.216-0.463,0.298c-0.031,0.021-0.062,0.031-0.093,0.041 c-0.144,0.062-0.309,0.124-0.494,0.175c-0.309,0.093-0.649,0.165-0.978,0.227c-0.607,0.124-1.174,0.185-1.431,0.227 c-0.103,0-0.154,0.01-0.154,0.01s0.494-3.902,1.174-5.755c0.504-1.38,1.935-1.997,2.625-2.224 C176.503,215.822,176.657,215.791,176.657,215.791z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#FF8482"
    },
    d: "M189.185,210.736c-1.246-0.051-3.902,2.893-5.384,4.262 c-0.123,0.113-0.237,0.216-0.35,0.319c-1.4,1.328-2.121,2.285-2.44,4.19c-0.082,0.463-0.175,0.978-0.268,1.493 c-0.072,0.371-0.134,0.751-0.206,1.101c-0.247,1.328-0.474,2.419-0.474,2.419s-0.165-0.782-0.247-1.884 c-0.041-0.484-0.062-1.029-0.041-1.596c0-0.237,0.01-0.474,0.031-0.721c0.175-2.141,1.977-5.281,3.861-6.558 c0.257-0.185,0.515-0.35,0.762-0.515c1.534-0.999,2.749-1.678,2.975-2.533c0.247-0.988-0.607-1.163-0.947-0.947 c-0.35,0.216-0.607,1.071-0.906,1.246c-0.031,0.021-0.062,0.031-0.103,0.051v0.01c-0.072,0.031-0.154,0.082-0.247,0.124 c-0.36,0.195-0.803,0.412-0.803,0.412s-5.363,3.387-6.135,4.334c-0.432,0.535-0.546,3.171-0.556,5.363 c0,1.081,0.01,2.059,0.021,2.615c0.01,0.299,0.021,0.473,0.021,0.473s-0.031-0.165-0.082-0.443 c-0.103-0.535-0.278-1.503-0.443-2.543c-0.237-1.503-0.432-3.171-0.329-3.922c0.216-1.544,2.007-3.305,2.656-3.603 c0.648-0.298-0.082-0.772-0.082-0.772s-1.76,1.544-2.532,2.656c-0.103,0.154-0.206,0.299-0.288,0.432 c-0.525,0.844-0.659,1.4-0.659,2.872c0,0.752-0.093,1.771-0.196,2.677c-0.062,0.556-0.124,1.071-0.185,1.451 c-0.051,0.422-0.093,0.679-0.093,0.679s0-0.247,0-0.638c0.01-0.371,0.01-0.875,0.01-1.421c0.01-0.926,0.01-1.987,0-2.8v-0.01 c0-0.391,0-0.731-0.01-0.968c-0.041-1.369-1.452-0.165-1.493,0.731c-0.021,0.35-0.041,1.791-0.01,3.624 c0.01,0.402,0.01,0.813,0.031,1.246c0.062,2.697,0.226,5.837,0.618,7.659c0.463,2.162-0.051,3.706-0.494,4.55 c-0.257,0.504-0.494,0.762-0.494,0.762l-1.647,1.184l-14.803,10.665c0.556,0.185,1.647,1.163,3.799,4.416 c1.791,2.697,3.212,4.561,4.262,5.816l-8.328,6.743c-1.06-0.062-2.11-0.319-3.14-0.854c-3.068-1.606-7.155-4.982-10.572-8.462 c-0.741-4.653-0.103-9.739-0.103-9.739l28.794-10.305l-0.185-2.038c0,0,0-7.494,0.865-10.171c-0.103,0-0.154,0.01-0.154,0.01 s0.494-3.902,1.174-5.755c0.504-1.38,1.935-1.997,2.625-2.224c0.257-0.607,0.618-1.173,1.174-1.668 c0.875-0.782,4.488-2.347,5.755-3.119c1.071-0.659,2.059-0.484,2.347-0.412c0.134-0.206,0.257-0.422,0.381-0.659 c1.071-2.049,2.924-1.266,3.212,0C189.175,210.263,189.196,210.5,189.185,210.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#FF8482"
    },
    d: "M195.136,222.616c-2.049-1.41-2.172-1.194-3.387,1.74 c-1.482,3.562-1.781,5.199-4.313,6.825c-2.522,1.637-3.562,1.194-3.562,1.194s-0.237,0.412-0.268-0.319v-0.278 c0.01-0.144,0.021-0.329,0.031-0.546c0,0.196-0.01,0.381-0.021,0.546c1.524-1.184,5.343-4.159,5.806-4.777 c0.576-0.782,0.576-2.049,2.038-3.902C192.902,221.278,194.714,220.866,195.136,222.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF786B"
    },
    d: "M202.321,206.053l-4.653,8.225l-4.066,7.196c-0.607,1.081-1.977,1.462-3.058,0.854l-4.653-2.635 c-1.071-0.607-1.452-1.977-0.844-3.047l4.344-7.68l4.375-7.752c0.607-1.071,1.987-1.452,3.058-0.844l4.653,2.635 C202.548,203.602,202.928,204.982,202.321,206.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54,
      fill: "#FFC5BF"
    },
    d: "M202.321,206.053l-4.653,8.225l-8.277-5.312l4.375-7.752 c0.607-1.071,1.987-1.452,3.058-0.844l4.653,2.635C202.548,203.602,202.928,204.982,202.321,206.053z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006070"
    },
    d: "M225.597,212.95l-14.227,25.798c0,0-2.357,1.431-3.891,0c-1.534-1.431-1.328-2.049-1.328-2.049 l1.863-3.5l12.569-23.523c0,0,1.029,0.175,2.306,0.762c0.113,0.051,0.237,0.103,0.35,0.165 C224.681,211.313,225.597,212.95,225.597,212.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#083364"
    },
    d: "M222.889,210.438c-2.296,4.128-13.444,24.274-13.393,25.293 c0.062,1.143-1.884,1.009-1.956-0.566c-0.01-0.268,0.165-0.978,0.474-1.966l12.569-23.523 C220.583,209.676,221.613,209.851,222.889,210.438z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#FF8482"
    },
    d: "M219.513,238.696c0.093-0.216,0.299-0.669,0.556-1.235 C219.832,238.048,219.626,238.48,219.513,238.696z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M212.327,258.657c0,0-27.599,44.307-30.327,47.035c-2.728,2.728-4.437,3.068-4.437,3.068 s-2.388-0.34-3.747-1.019c-1.359-0.69-11.931-7.844-11.931-7.844s-0.556-8.308,1.338-14.443 c0.206-0.669,0.443-1.307,0.71-1.915c2.728-6.135,7.155-11.592,7.155-11.592l0.01,0.01l4.077,2.213l3.418,1.863l23.173-26.241 c0,0,3.068-0.34,6.475,2.728c0.628,0.566,1.163,1.132,1.627,1.678C211.874,256.619,212.327,258.657,212.327,258.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M226.389,249.135c-1.04,2.491-4.334,3.953-7.155,5.405c-3.624,1.863-6.908,4.118-6.908,4.118 s-2.162-1.235-4.458-2.779c-0.484-0.329-0.978-0.669-1.462-1.009c-2.749-1.977-4.643-5.075-4.643-5.075 s-1.174-6.115-0.844-9.183c0.329-3.068,2.368-6.64,3.191-7.68c1.524-1.956,2.275-3.14,3.809-4.457 c0.196-0.165,0.381-0.288,0.556-0.391c1.266-0.679,2.193,0.144,2.193,0.144s-1.637,4.715-1.637,6.465 c0,1.76,2.635,3.624,3.397,3.51c0.597-0.093,2.244-2.007,3.459-3.377c0.36-0.401,0.68-0.762,0.926-1.009 c0.916-0.906,2.646-2.419,4.406-1.153c0.154,0.103,0.309,0.237,0.463,0.391c0.051,0.051,0.103,0.103,0.144,0.165 c0.165,0.165,0.319,0.371,0.474,0.597c0.504,0.752,0.999,1.657,1.452,2.676c0.196,0.432,0.391,0.885,0.576,1.359 c0.113,0.288,0.226,0.597,0.34,0.896c0.01,0.01,0,0.021,0,0.021c0.298,0.803,0.556,1.616,0.803,2.44 c0.134,0.484,0.268,0.957,0.391,1.431c0.031,0.124,0.062,0.247,0.093,0.371c0.01,0.031,0.02,0.072,0.031,0.103 c0.237,0.988,0.432,1.956,0.587,2.852v0.01c0.041,0.268,0.082,0.525,0.113,0.782 C226.812,247.642,226.688,248.435,226.389,249.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M222.303,233.817c0,0-0.329,1.256-1.102,2.285c-0.257,0.35-0.566,0.669-0.927,0.896 c-0.01,0.01-0.021,0.01-0.031,0.021c-0.206,0.134-0.432,0.237-0.679,0.309c-1.977,0.546-4.941-0.329-4.941-0.329 s0.628-0.793,1.266-2.172c0.247-0.535,0.494-1.174,0.71-1.884c0.772-2.522,0.052-3.902,0.052-3.902l1.946-3.366l0.906-1.575 c0,0,1.596,2.594,1.812,4.128v0.01c0.01,0.062,0.021,0.134,0.031,0.206c0.021,0.103,0.031,0.216,0.062,0.34 c0.01,0.072,0.021,0.154,0.031,0.227c0.196,1.019,0.494,2.327,0.69,3.376C222.231,232.973,222.303,233.487,222.303,233.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M224.917,236.339c0,0.01,0,0.01,0,0.021c0,0.371-0.01,0.731-0.041,1.071 c-0.041,0.453-0.103,0.875-0.196,1.256c0,0.021,0,0.041-0.01,0.062c-0.103,0.463-0.237,0.865-0.391,1.204 c0,0-0.082-0.072-0.947-0.937c-0.082-0.093-0.185-0.185-0.288-0.288l-0.195-0.196c-0.947-0.947-1.616-1.441-1.647-2.43 c-0.031-0.371,0.041-0.824,0.226-1.41c0.082-0.257,0.144-0.556,0.175-0.875c0-0.01,0.01-0.021,0.01-0.031 c0.031-0.237,0.051-0.484,0.072-0.731c0.062-1.431-0.124-3.088-0.247-4.046c-0.01-0.072-0.021-0.154-0.031-0.227 c-0.021-0.134-0.041-0.257-0.062-0.34c-0.01-0.093-0.021-0.154-0.021-0.196c0.237,0.278,2.975,3.696,3.387,6.012 C224.845,234.99,224.907,235.69,224.917,236.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M226.688,240.714v0.01c0,1.143-0.299,1.843-0.587,2.244c-0.041,0.051-0.082,0.103-0.113,0.144 c-0.216,0.257-0.402,0.35-0.402,0.35s0,0.01-0.01,0.031c-0.01,0.021-0.021,0.041-0.021,0.062 c-0.062,0.103-0.165,0.196-0.36-0.175c-0.093-0.185-0.196-0.494-0.329-0.957c-0.01-0.051-0.031-0.103-0.041-0.165 c-0.494-1.884-0.278-2.419-0.154-3.49c0,0,0.01-0.01,0-0.021c0.01-0.02,0.01-0.041,0.01-0.062 c0.01-0.082,0.02-0.175,0.031-0.268c0.021-0.299,0.052-0.618,0.093-0.947v-0.01c0.031-0.381,0.072-0.762,0.113-1.102 c0-0.01,0-0.01,0-0.021c0.072-0.628,0.124-1.102,0.124-1.102C226.029,237.214,226.688,238.532,226.688,240.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFAA"
    },
    d: "M226.462,249.166c-0.021,0-0.051-0.01-0.072-0.031c-0.319-0.123-0.576-0.906-0.741-1.884 c-0.206-1.235-0.257-2.779-0.093-3.696c0-0.021,0.01-0.041,0.021-0.062c0.021-0.144,0.051-0.268,0.082-0.371 c0.021-0.031,0.031-0.062,0.041-0.093c0.051-0.124,0.113-0.257,0.165-0.391c0.309-0.679,0.618-1.421,0.824-1.915v-0.01 c0.134-0.329,0.216-0.535,0.216-0.535C228.768,242.804,227.347,249.279,226.462,249.166z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#FF8482"
    },
    d: "M206.964,238.202c-1.421-1.544-1.029-3.984,0.515-6.557 c0.896-1.493,1.318-2.635,0.999-3.562c1.266-0.679,2.193,0.144,2.193,0.144s-1.637,4.715-1.637,6.465 c0,1.76,2.635,3.624,3.397,3.51C211.607,238.84,208.374,239.746,206.964,238.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.46,
      fill: "#FF8482"
    },
    d: "M226.462,249.166c-0.021,0-0.051-0.01-0.072-0.031 c-1.04,2.491-4.334,3.953-7.155,5.405c-3.624,1.863-6.908,4.118-6.908,4.118S184.728,302.965,182,305.693 c-2.728,2.728-4.437,3.068-4.437,3.068s-2.388-0.34-3.747-1.019c-1.359-0.69-11.931-7.844-11.931-7.844 s-0.556-8.308,1.338-14.443c2.903-5.333,6.094-10.614,7.875-13.496c0.854-1.39,1.379-2.224,1.379-2.224s1.73,1.451,2.697,4.437 c0.155,0.453,0.288,0.947,0.391,1.482c0.762,3.994-4.252,19.436-4.252,19.436s5.662,6.3,8.102,2.306 c2.285-3.706,24.213-35.794,28.454-41.518c0.319-0.422,0.535-0.7,0.638-0.813c0.226-0.247,0.71-0.535,1.359-0.865 c3.706-1.832,13.074-4.633,14.721-5.95c0.401-0.319,0.751-0.648,1.06-0.999c0.381-0.412,0.69-0.844,0.926-1.277v-0.01 c0.505-0.926,0.669-1.843,0.463-2.615c-0.124-0.443-0.494-0.505-0.937-0.381c-0.051,0.01-0.093,0.02-0.144,0.041 c-0.093,0.031-0.196,0.072-0.299,0.113c-0.154,0.082-0.309,0.175-0.463,0.257c-0.731,0.432-1.38,0.999-1.38,0.999 s0.463-0.793,1.05-1.956c0.196-0.37,0.401-0.772,0.607-1.215c0.051-0.093,0.093-0.196,0.144-0.298 c0.906-1.925,0.638-2.574-0.124-3.469c-0.154-0.175-0.371-0.154-0.618-0.01c-0.031,0.01-0.051,0.021-0.072,0.031v0.01 c-0.154,0.093-0.319,0.226-0.474,0.381c-0.329,0.319-0.679,0.741-0.999,1.163c-0.556,0.741-1.019,1.482-1.153,1.699 c0.093-0.206,0.484-0.978,0.865-1.987c0.268-0.68,0.525-1.452,0.71-2.234c0.082-0.371,0.154-0.751,0.196-1.112 c0.247-2.45-1.297-5.024-1.678-3.48c-0.031,0.134-0.082,0.299-0.144,0.484c-0.082,0.247-0.185,0.525-0.298,0.834 c-0.062,0.175-0.144,0.371-0.216,0.566c0,0.01-0.01,0.021-0.01,0.031c-0.412,1.019-0.916,2.213-1.328,3.181 c-0.041,0.082-0.082,0.154-0.113,0.237c0.031-0.072,0.062-0.144,0.082-0.216c0.474-1.204,0.957-2.831,0.978-4.355 c0.01-0.443-0.031-0.865-0.113-1.276c-0.576-2.78-1.565-4.622-2.512-5.713l0.906-1.575c0,0,1.596,2.594,1.812,4.128v0.01h0.01 v0.01c0.237,0.278,2.975,3.696,3.387,6.012c0.134,0.731,0.196,1.431,0.206,2.08c0.072-0.628,0.124-1.102,0.124-1.102 c0.988,1.977,1.647,3.294,1.647,5.477c0.134-0.329,0.216-0.535,0.216-0.535C228.768,242.804,227.347,249.279,226.462,249.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB337"
    },
    d: "M163.933,264.443c0,16.78-10.202,22.905-14.145,24.645c-0.947,0.422-1.534,0.587-1.534,0.587 s-7.844-1.369-9.543-6.135c-1.709-4.777-1.369-7.505-8.184-11.592c-3.922-2.357-8.534-7.422-11.993-13.259 c-2.543-4.293-4.468-8.997-5.054-13.331c-1.359-10.222,6.825-21.474,17.387-18.746c10.562,2.728,14.32,7.505,16.698,14.999 c2.388,7.505,5.116,6.815,8.863,10.912c3.758,4.087,4.777,6.475,5.116,8.853C161.884,263.763,163.933,264.443,163.933,264.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#730303"
    },
    d: "M152.784,283.632c-1.071,2.357-1.966,4.128-2.996,5.456 c-0.947,0.422-1.534,0.587-1.534,0.587s-7.844-1.369-9.543-6.135c-1.709-4.777-1.369-7.505-8.184-11.592 c-3.922-2.357-8.534-7.422-11.993-13.259c0.021-2.584,0.278-5.384,0.793-8.514c2.316-13.898,6.691-18.787,6.691-18.787 s-2.316,10.037-0.515,16.471c1.801,6.434,4.89,8.493,9.265,11.581c4.375,3.088,4.89,2.316,10.037,8.493 c5.147,6.177,4.89,3.346,9.78,1.287C154.586,269.219,155.358,277.97,152.784,283.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD796"
    },
    d: "M174.495,275.015c-1.359,6.815-5.796,23.173-9.203,26.59c-1.246,1.246-2.594,1.678-3.871,1.544 c-2.213-0.226-4.252-2.11-5.333-4.272c-1.699-3.407-5.106-2.049-8.864-5.456c-3.747-3.408-2.378-8.184-2.378-8.184 s3.562-7.247,6.98-13.63c2.09-3.881,4.128-7.443,5.291-8.864c3.068-3.747,5.446-4.437,9.203-2.049 c3.747,2.388,0,3.747,2.718,6.475c1.287,1.287,2.862,1.585,4.036,2.255C174.413,270.177,175.226,271.402,174.495,275.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "#A80425"
    },
    d: "M174.495,275.015c-1.359,6.815-5.796,23.173-9.203,26.59 c-1.246,1.246-2.594,1.678-3.871,1.544c-2.213-0.226-4.252-2.11-5.333-4.272c-1.699-3.407-5.106-2.049-8.864-5.456 c-3.747-3.408-2.378-8.184-2.378-8.184s3.562-7.247,6.98-13.63c-1.328,4.18-2.707,7.783-2.903,12.281 c-0.257,5.919,0,6.691,3.346,6.434c3.346-0.257,3.346,0,5.919-6.177c2.574-6.177,5.147-11.581,4.89-5.405 c-0.257,6.177-2.059,9.265-2.316,13.125c-0.257,3.861,5.405,3.088,6.177-3.088s3.603-10.294,5.147-15.699 c0.412-1.462,0.721-2.697,0.988-3.655C174.413,270.177,175.226,271.402,174.495,275.015z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000934370822627484460000002586605001967069090_",
    x: 10.2,
    y: 186.272,
    width: 182.512,
    height: 313.728
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036967455077904659070000011978550173120827325_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000934370822627484460000002586605001967069090_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036967455077904659070000011978550173120827325_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5176A1"
    },
    d: "M94.396,378.635c-7.499-2.386-12.612-10.567-6.817-20.111c5.795-9.544,5.795-24.201,5.795-24.201 H72.24c0,0,1.023,4.431-3.409,11.589c-4.431,7.158-8.521,11.93-6.135,20.451c2.386,8.521,12.612,13.634,12.612,13.634 L94.396,378.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5176A1"
    },
    d: "M155.41,400.791H63.377c-6.374,0-11.589-5.215-11.589-11.589v-0.682 c0-6.374,5.215-11.589,11.589-11.589h92.032c6.374,0,11.589,5.215,11.589,11.589v0.682 C166.998,395.576,161.783,400.791,155.41,400.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083364"
    },
    d: "M144.6,400.791H52.568c-6.374,0-11.589-5.215-11.589-11.589v-0.682 c0-6.374,5.215-11.589,11.589-11.589H144.6c6.374,0,11.589,5.215,11.589,11.589v0.682 C156.189,395.576,150.974,400.791,144.6,400.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083364"
    },
    d: "M105.68,397.68v85.31c0,3.61-2.59,6.64-6.01,7.31c-0.47,0.09-0.95,0.14-1.44,0.14h-1.99 c-4.1,0-7.45-3.35-7.45-7.45v-85.31c0-4.1,3.35-7.45,7.45-7.45h1.99c0.49,0,0.97,0.05,1.44,0.14 C103.09,391.04,105.68,394.07,105.68,397.68z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#083364"
    },
    points: "105.68,477.68 105.64,481.64 105.3,515.97 92.92,515.97 90.29,477.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#083364"
    },
    points: "95.919,475.806 95.919,495.324 45.622,495.324 45.622,490.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#083364"
    },
    points: "149.97,490.07 149.97,495.32 99.67,495.32 99.67,475.81 105.68,477.51  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5176A1"
    },
    d: "M149.97,490.07v4.44l-44.29-11.81l-6.01-1.6v-90.73c3.42,0.67,6.01,3.7,6.01,7.31v79.83 L149.97,490.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083364"
    },
    d: "M106.05,520.47v4.13c0,2.45-1.58,4.55-3.78,5.31v0.01c-0.58,0.2-1.2,0.31-1.85,0.31h-1.5 c-3.1,0-5.63-2.53-5.63-5.63v-4.13c0-1.84,0.89-3.48,2.27-4.5c0.94-0.71,2.1-1.13,3.36-1.13h1.5c0.65,0,1.27,0.11,1.85,0.32 c0.03,0,0.06,0.01,0.08,0.04c0.01-0.01,0.01,0,0.01,0c0.51,0.18,0.99,0.44,1.42,0.77C105.16,516.99,106.05,518.63,106.05,520.47z "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#083364"
    },
    cx: 54.255,
    cy: 503.582,
    r: 8.258
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#083364"
    },
    cx: 138.708,
    cy: 503.582,
    r: 8.258
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083364"
    },
    d: "M86.678,378.635c-7.499-2.386-12.612-10.567-6.817-20.111c5.795-9.544,5.795-24.201,5.795-24.201 H64.523c0,0,1.023,4.431-3.409,11.589c-4.431,7.158-8.521,11.93-6.135,20.451c2.386,8.521,12.612,13.634,12.612,13.634 L86.678,378.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5176A1"
    },
    d: "M59.708,337.181c12.23,2.432,35.668,2.297,46.713,2.074c3.407-0.069,6.138-2.826,6.174-6.233 c0.148-14.19-0.421-50.638-8.996-81.187c-7.822-27.866-15.293-39.079-18.894-43.193c-1.195-1.365-2.921-2.141-4.735-2.141H39.304 c-4.253,0-7.288,4.122-6.017,8.181c4.736,15.122,14.511,48.252,17.82,73.966c2.938,22.824,3.478,36.059,3.509,42.388 C54.631,334.038,56.765,336.596,59.708,337.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#083364"
    },
    d: "M51.528,337.181c12.23,2.432,35.668,2.297,46.713,2.074c3.407-0.069,6.138-2.826,6.174-6.233 c0.148-14.19-0.421-50.638-8.996-81.187c-7.822-27.866-15.293-39.079-18.894-43.193c-1.195-1.365-2.921-2.141-4.735-2.141H31.123 c-4.253,0-7.288,4.122-6.017,8.181c4.736,15.122,14.511,48.252,17.821,73.966c2.938,22.824,3.478,36.059,3.509,42.388 C46.45,334.038,48.585,336.596,51.528,337.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5176A1"
    },
    d: "M106.05,520.47v4.13c0,2.45-1.58,4.55-3.78,5.31c1.19-1.29,1.78-5.54,1.39-10.1 c-0.18-2.06-0.48-3.2-0.75-3.84c-0.23-0.51-0.43-0.7-0.55-0.77c0,0,0-0.01-0.01,0c-0.05-0.04-0.08-0.04-0.08-0.04V481.1 c0,0,1.94,0.17,3.37,0.54l-0.34,34.33h-1.52C105.16,516.99,106.05,518.63,106.05,520.47z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalizeDesign);
export default __webpack_public_path__ + "static/media/Finalize Design.5ca3f30e3df64751ee8ec189bf186981.svg";
export { ForwardRef as ReactComponent };